<template>
  <div class="result-size-reco-noo-cleed result-final space-evenly">
    <p v-if="resultSizes.response_one" v-html="resultSizes.response_one"></p>
    <p v-if="resultSizes.value" class="value-result-size-reco-noo-bold-cleed margin-bottom-10-result-size-reco-noo-cleed margin-top-10-result-size-reco-noo-cleed">
      {{ resultSizes.value }}
    </p>
    <p v-if="resultSizes.response_two" class="margin-bottom-10-result-size-reco-noo-cleed" v-html="resultSizes.response_two"></p>
    <p v-if="resultSizes.response_three" class="margin-top-10-result-size-reco-noo-cleed" v-html="resultSizes.response_three"></p>
    <ButtonSubmit
      id="add-to-cart-cleed"
      :text="valueText['button']"
      class-name="bold-result-size-reco-noo-cleed validateButtonSubmitNoo-cleed validateCursorPointer-cleed"
      @submitButton="$emit('add-to-cart')"
    />
  </div>
</template>

<script>
import ButtonSubmit from "@/components/modal/ui/ButtonSubmit.vue";

export default {
  name: "ResultSizeRecoNoo",
  components: {
    ButtonSubmit,
  },
  props: {
    valueText: {
      type: Object,
      default: () => {},
    },
    resultSizes : {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style scoped>
.bold-result-size-reco-noo-cleed {
  font-weight: bolder;

}

.value-result-size-reco-noo-bold-cleed {
  font-size: 69px;

}

.margin-top-10-result-size-reco-noo-cleed {
  margin-top: 10px;
}

.margin-bottom-10-result-size-reco-noo-cleed {
  margin-bottom: 10px;
}
</style>
